export default __webpack_public_path__ + "static/media/(18).703373be.jpg";